import * as React from "react"
import { cn } from "lib/utils"

export interface FloatingInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  required?: boolean
}

const FloatingInput = React.forwardRef<HTMLInputElement, FloatingInputProps>(
  ({ className, type = "text", label, required = false, ...props }, ref) => {
    const [isFocused, setIsFocused] = React.useState(false)
    const [hasValue, setHasValue] = React.useState(false)

    // value prop 변경 감지하여 hasValue 상태 업데이트
    React.useEffect(() => {
      setHasValue(!!props.value && props.value !== '')
    }, [props.value])

    const handleFocus = () => setIsFocused(true)
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(false)
      setHasValue(e.target.value !== '')
      if (props.onBlur) props.onBlur(e)
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setHasValue(e.target.value !== '')
      if (props.onChange) props.onChange(e)
    }

    const isLabelFloating = isFocused || hasValue

    return (
      <div className="relative">
        <input
          type={type}
          className={cn(
            "peer h-14 w-full bg-[#f8f8fb] px-3 pt-3 pb-2 text-sm transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium outline-none disabled:cursor-not-allowed disabled:opacity-50",
            "placeholder-transparent",
            className
          )}
          style={{
            border: isFocused ? '2px solid rgb(var(--primary))' : '1px solid rgb(var(--border))',
            borderRadius: '6px'
          }}
          ref={ref}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          placeholder=" "
          {...props}
        />
        
        <label
          className={cn(
            "absolute transition-all duration-200 pointer-events-none px-1 text-seconredary",
            isLabelFloating
              ? "-top-2 left-2 text-xs bg-[#f8f8fb] z-10"
              : "top-1/2 left-3 -translate-y-1/2 text-sm bg-[#f8f8fb]"
          )}
          style={{
            color: isLabelFloating ? 'rgb(var(--primary))' : 'rgb(var(--muted-foreground))'
          }}
        >
          {label}{required && "*"}
        </label>
      </div>
    )
  }
)
FloatingInput.displayName = "FloatingInput"

// Prezem 프로젝트 전용 이름으로도 export
const PrezemInput = FloatingInput

export { FloatingInput, PrezemInput } 